export default __webpack_public_path__ + "static/media/Calendar_Icon.8342e3b8.svg";